(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const initializeCartSections = (root = document) => {
    root.querySelectorAll('[data-cart-section]').forEach((section) => {
      if (section.dataset.quantityReady === 'true') return;

      section.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const stepper = button.closest('.quantity-stepper');
          const input = stepper ? stepper.querySelector('input[type="number"]') : null;
          if (!input) return;

          const nextValue = Math.max(0, Number(input.value || 0) + Number(button.dataset.quantityChange));
          input.value = String(nextValue);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      section.dataset.quantityReady = 'true';
    });
  };

  initializeCartSections();
  document.addEventListener('shopify:section:load', (event) => initializeCartSections(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const initializeProductSections = (root = document) => {
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.variantsReady === 'true') return;

      const variantDataElement = section.querySelector('[data-product-variants]');
      const form = section.querySelector('.product-form');
      if (!variantDataElement || !form) return;

      const variants = JSON.parse(variantDataElement.textContent);
      const optionSelects = Array.from(section.querySelectorAll('[data-option-select]'));
      const variantInput = form.querySelector('[data-variant-input]');
      const price = section.querySelector('[data-product-price]');
      const productImage = section.querySelector('.product-main-image');
      const submit = form.querySelector('[data-product-submit]');
      const status = form.querySelector('[data-variant-status]');
      const thumbnails = Array.from(section.querySelectorAll('[data-gallery-thumbnail]'));
      const selectedColorThumbnail = section.querySelector('[data-view-type="color"]');
      const sizeChartTrigger = section.querySelector('[data-size-chart-trigger]');
      const sizeChartDialog = section.querySelector('[data-size-chart-dialog]');

      const selectedOptions = () => optionSelects.map((select) => select.value);

      const optionMatches = (variant, choices) => variant.options.every((value, index) => value === choices[index]);

      const setMainImage = (url, alt, viewType) => {
        if (!url || !productImage) return;
        productImage.src = url;
        productImage.removeAttribute('srcset');
        productImage.alt = alt;

        thumbnails.forEach((thumbnail) => {
          const isActive = thumbnail.dataset.viewType === viewType;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const updateSelectedColorThumbnail = (variant) => {
        if (!selectedColorThumbnail || !variant.image) return;
        selectedColorThumbnail.dataset.galleryImage = variant.image;
        selectedColorThumbnail.dataset.galleryImageAlt = variant.image_alt;
        const thumbnailImage = selectedColorThumbnail.querySelector('img');
        if (!thumbnailImage) return;
        thumbnailImage.src = variant.thumbnail || variant.image;
        thumbnailImage.removeAttribute('srcset');
        thumbnailImage.alt = variant.image_alt;
      };

      const refreshOptionAvailability = (choices) => {
        optionSelects.forEach((select, selectIndex) => {
          Array.from(select.options).forEach((option) => {
            const candidateChoices = choices.slice();
            candidateChoices[selectIndex] = option.value;
            option.disabled = !variants.some((variant) => variant.available && optionMatches(variant, candidateChoices));
          });
        });
      };

      const updateProduct = (updateUrl = true) => {
        const choices = selectedOptions();
        const variant = variants.find((item) => optionMatches(item, choices));
        refreshOptionAvailability(choices);

        if (!variant) {
          variantInput.value = '';
          submit.disabled = true;
          submit.textContent = submit.dataset.unavailableLabel;
          status.textContent = submit.dataset.unavailableLabel;
          status.hidden = false;
          return;
        }

        variantInput.value = variant.id;
        price.textContent = variant.price;
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.dataset.addLabel : submit.dataset.soldOutLabel;
        status.textContent = variant.available ? '' : submit.dataset.soldOutLabel;
        status.hidden = variant.available;

        if (variant.image) {
          updateSelectedColorThumbnail(variant);
          setMainImage(variant.image, variant.image_alt, 'color');
        }

        if (updateUrl && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      };

      optionSelects.forEach((select) => {
        select.addEventListener('change', () => updateProduct(true));
      });

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          setMainImage(thumbnail.dataset.galleryImage, thumbnail.dataset.galleryImageAlt, thumbnail.dataset.viewType);
        });
      });

      if (sizeChartTrigger && sizeChartDialog) {
        sizeChartTrigger.addEventListener('click', () => {
          if (typeof sizeChartDialog.showModal === 'function') {
            sizeChartDialog.showModal();
          } else {
            sizeChartDialog.setAttribute('open', '');
          }
        });

        sizeChartDialog.addEventListener('click', (event) => {
          if (event.target === sizeChartDialog) sizeChartDialog.close();
        });
      }

      section.dataset.variantsReady = 'true';
      updateProduct(false);
    });
  };

  initializeProductSections();
  document.addEventListener('shopify:section:load', (event) => initializeProductSections(event.target));

  } catch(e) { console.error(e); }
})();
})();
